var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3132 12.6667V3.33337C14.3132 2.00004 13.6465 1.33337 12.3132 1.33337H9.64648C8.31315 1.33337 7.64648 2.00004 7.64648 3.33337V12.6667C7.64648 14 8.31315 14.6667 9.64648 14.6667H12.3132C13.6465 14.6667 14.3132 14 14.3132 12.6667Z",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 4H10.9798",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 12H10.3132",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 9.30005L10.9798 9.33338",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 6.66663H9.64648",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65986 1.33337C2.57319 1.33337 1.68652 2.22004 1.68652 3.30004V11.94C1.68652 12.24 1.81319 12.6934 1.96652 12.9534L2.51319 13.86C3.13986 14.9067 4.17319 14.9067 4.79986 13.86L5.34653 12.9534C5.49986 12.6934 5.62652 12.24 5.62652 11.94V3.30004C5.62652 2.22004 4.73986 1.33337 3.65986 1.33337Z",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62652 4.66663H1.68652",
    stroke: "#1E293B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/Unit.2e1fb82a5a4a263c322f56018b27c345.svg";
export { ForwardRef as ReactComponent };